import { render, staticRenderFns } from "./legend-cop.vue?vue&type=template&id=77125a32&scoped=true&"
import script from "./legend-cop.vue?vue&type=script&lang=js&"
export * from "./legend-cop.vue?vue&type=script&lang=js&"
import style0 from "./legend-cop.vue?vue&type=style&index=0&id=77125a32&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77125a32",
  null
  
)

export default component.exports